import type { Piece, RoomSnapshot } from '../../../shared/types';

interface BoardProps {
  snapshot: RoomSnapshot;
  myPiece: Piece | null;
  youCanMove: boolean;
  onMove: (index: number) => void;
}

function PieceGlyph({ piece }: { piece: Piece }) {
  if (!piece) return null;
  return piece === 'X' ? (
    <svg viewBox="0 0 100 100" className="w-3/5 h-3/5 text-xpiece drop-shadow-[0_0_16px_rgba(255,107,107,0.45)]">
      <line x1="22" y1="22" x2="78" y2="78" stroke="currentColor" strokeWidth="13" strokeLinecap="round" />
      <line x1="78" y1="22" x2="22" y2="78" stroke="currentColor" strokeWidth="13" strokeLinecap="round" />
    </svg>
  ) : (
    <svg viewBox="0 0 100 100" className="w-3/5 h-3/5 text-opiece drop-shadow-[0_0_16px_rgba(78,205,196,0.45)]">
      <circle cx="50" cy="50" r="29" fill="none" stroke="currentColor" strokeWidth="13" />
    </svg>
  );
}

export default function Board({ snapshot, myPiece, youCanMove, onMove }: BoardProps) {
  const winSet = new Set(snapshot.winLine ?? []);
  const gameOver = snapshot.phase === 'gameover';

  return (
    <div className="grid grid-cols-3 gap-2.5 sm:gap-3 w-full aspect-square max-w-[420px]">
      {snapshot.board.map((cell, i) => {
        const playable = !gameOver && youCanMove && cell === '';
        const isWin = winSet.has(i);
        return (
          <button
            key={i}
            disabled={!playable}
            onClick={() => onMove(i)}
            aria-label={`Cell ${i + 1}${cell ? `, ${cell}` : ', empty'}`}
            className={[
              'ttt-glass rounded-2xl flex items-center justify-center transition-all duration-150',
              'aspect-square',
              isWin ? 'ttt-win-cell ring-2 ring-ttt-accent' : '',
              playable
                ? 'cursor-pointer hover:bg-white/10 hover:scale-[1.03] active:scale-[0.97]'
                : 'cursor-default',
              !cell && !gameOver && youCanMove ? 'hover:ring-1 hover:ring-white/25' : '',
            ].join(' ')}
          >
            {cell ? (
              <div
                className={[
                  'w-full h-full flex items-center justify-center',
                  isWin ? 'ttt-win-cell' : 'ttt-pop',
                ].join(' ')}
              >
                <PieceGlyph piece={cell} />
              </div>
            ) : (
              !gameOver && youCanMove && myPiece && (
                <span className="text-4xl font-display font-bold opacity-0 hover:opacity-20 transition-opacity"
                      style={{ color: myPiece === 'X' ? '#ff6b6b' : '#4ecdc4' }}>
                  {myPiece}
                </span>
              )
            )}
          </button>
        );
      })}
    </div>
  );
}
